import DateUtils from '@/utils/dateUtils'
import CommonState from './CommonState'

export const BEFORE_MONTH	= new CommonState('BEFORE_MONTH', '前一月', 'Before Month')
export const BEFORE_WEEK = new CommonState('BEFORE_WEEK', '前一周', 'Before week')
export const BEFORE_YESTERDAY	= new CommonState('BEFORE_YESTERDAY', '前天', 'Before Yesterday')
export const YESTERDAY = new CommonState('YESTERDAY', '昨天', 'Yesterday')
export const TODAY = new CommonState('TODAY', '当天', 'Today')
export const TOMORROW = new CommonState('TOMORROW', '明天', 'Tomorrow')
export const AFTER_TOMORROW	= new CommonState('AFTER_TOMORROW', '后天', 'After Tomorrow')
export const AFTER_WEEK	= new CommonState('AFTER_WEEK', '后一周', 'After Week')
export const AFTER_MONTH = new CommonState('AFTER_MONTH', '后一月', 'After Nonth')
export const CUSTOM = new CommonState('CUSTOM', '指定日期', 'Specified Date')

export const TIME_RANGES = [
  BEFORE_MONTH,
  BEFORE_WEEK,
  BEFORE_YESTERDAY,
  YESTERDAY,
  TODAY,
  TOMORROW,
  AFTER_TOMORROW,
  AFTER_WEEK,
  AFTER_MONTH,
  CUSTOM
]

export function calcTimeRange(type) {
  const start = new Date()
  const end = new Date()
  switch (type) {
    case BEFORE_MONTH.code :
      start.setMonth(start.getMonth() - 1)
      break
    case BEFORE_WEEK.code :
      start.setDate(start.getDate() - 6)
      break
    case BEFORE_YESTERDAY.code :
      start.setDate(start.getDate() - 2)
      end.setDate(end.getDate() - 2)
      break
    case YESTERDAY.code :
      start.setDate(start.getDate() - 1)
      end.setDate(end.getDate() - 1)
      break
    case TODAY.code :
      break
    case TOMORROW.code :
      start.setDate(start.getDate() + 1)
      end.setDate(end.getDate() + 1)
      break
    case AFTER_TOMORROW.code :
      start.setDate(start.getDate() + 2)
      end.setDate(end.getDate() + 2)
      break
    case AFTER_WEEK.code :
      end.setDate(end.getDate() + 6)
      break
    case AFTER_MONTH.code :
      end.setMonth(end.getMonth() + 1)
      break
    default:
      return null
  }
  return [DateUtils.formatStandardDate(start), DateUtils.formatStandardDate(end)]
}
